import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import '../../node_modules/ninjabootstrap/dist/js/bootstrap.bundle.min';
import { Fancybox } from "../../node_modules/@fancyapps/ui/dist/fancybox/fancybox.esm";
import owl from "../../node_modules/owl.carousel/dist/owl.carousel";
import AOS from "../../node_modules/aos/dist/aos";
import { smoothScroll } from "./components/smooth-scroll.js";
import noUiSlider from "../../node_modules/nouislider/dist/nouislider";


// Initialise our components on jQuery.ready…
jQuery(function ($) {
    //     ExampleComponent1.init();
    //     ExampleModule2.init();
    //     ReplaceObfuscatedEmailAddresses.init();
    //     AnimateOnPageLinks.init();

    //ANIMATE ON SCROLL
    AOS.init({
        duration: 1400
    });

    //FANCYBOX
    Fancybox.bind("[data-fancybox]", {
    });

    //FANCYAPP CAROUSEL
    if ($('#myCarousel').length) {
        const container = document.getElementById("myCarousel");
        const options = {
            Autoplay: {
                timeout: 6000,
            }
        };
        new Carousel(container, options, { Autoplay });

    }

    //NOUISLIDER
    if ($('#areaSlider').length) {
        var areaSlider = document.getElementById('areaSlider');
        noUiSlider.create(areaSlider, {
            start: [$(areaSlider).data('min-value'), $(areaSlider).data('max-value')],
            connect: true,
            range: {
                'min': $(areaSlider).data('min-value'),
                'max': $(areaSlider).data('max-value')
            },
            step: 10
        });

        var areaSliderValue = document.getElementById('areaSliderValue');

        areaSlider.noUiSlider.on('update', function (values) {
            areaSliderValue.innerHTML = values[0].replace('.00', '') + ' - ' + values[1].replace('.00', '');
            $(areaSlider).data('value-min-now', values[0].replace('.00', ''));
            $(areaSlider).data('value-max-now', values[1].replace('.00', ''));
        });

        areaSlider.noUiSlider.on('end', function () {
            filtrarImoveis()
        });
    }

    if ($('#areaSliderMobile').length) {
        var areaSliderMobile = document.getElementById('areaSliderMobile');
        noUiSlider.create(areaSliderMobile, {
            start: [$(areaSliderMobile).data('min-value'), $(areaSliderMobile).data('max-value')],
            connect: true,
            range: {
                'min': $(areaSliderMobile).data('min-value'),
                'max': $(areaSliderMobile).data('max-value')
            },
            step: 10
        });

        var areaSliderMobileValue = document.getElementById('areaSliderMobileValue');

        areaSliderMobile.noUiSlider.on('update', function (values) {
            areaSliderMobileValue.innerHTML = values[0].replace('.00', '') + ' - ' + values[1].replace('.00', '');
            $(areaSliderMobile).data('value-min-now', values[0].replace('.00', ''));
            $(areaSliderMobile).data('value-max-now', values[1].replace('.00', ''));
        });

        areaSliderMobile.noUiSlider.on('end', function () {
            filtrarImoveis()
        });
    }

    //IMOVEIS FILTRO CHECKBOX
    $('#imoveisFiltro .filtro .form-check-input').on('change', function (e) {
        filtrarImoveis()
    });

    $('#imoveisFiltro #filtroBuscaEmpreendimento').on('keyup', function () {
        filtrarImoveis()
    });

    //FILTRAR IMOVEIS
    function filtrarImoveis() {
        var busca = $('#filtroBuscaEmpreendimento').val();

        var estagio = $('#imoveisFiltro .filtro .filtro_estagio .form-check-input:checked[type=checkbox]').map(function () {
            return $(this).val();
        }).get();

        var finalidade = $('#imoveisFiltro .filtro .filtro_finalidade .form-check-input:checked[type=checkbox]').map(function () {
            return $(this).val();
        }).get();

        var bairro = $('#imoveisFiltro .filtro .filtro_bairro .form-check-input:checked[type=checkbox]').map(function () {
            return $(this).val();
        }).get();

        var quarto = $('#imoveisFiltro .filtro .filtro_quarto .form-check-input:checked[type=checkbox]').map(function () {
            return $(this).val();
        }).get();

        var area_min, area_max;
        if ($(window).width() <= 768) {
            area_min = $('#imoveisFiltro .filtro .filtro_area #areaSliderMobile').data('value-min-now');
            area_max = $('#imoveisFiltro .filtro .filtro_area #areaSliderMobile').data('value-max-now');
        } else {
            area_min = $('#imoveisFiltro .filtro .filtro_area #areaSlider').data('value-min-now');
            area_max = $('#imoveisFiltro .filtro .filtro_area #areaSlider').data('value-max-now');
        }

        $('#imoveisLista').addClass('loading');
        $.ajax({
            type: 'POST',
            url: ajaxurl,
            data: { 
                "action": "filtro-imoveis",
                estagio: JSON.stringify(estagio),
                finalidade: JSON.stringify(finalidade),
                bairro: JSON.stringify(bairro),
                quarto: JSON.stringify(quarto),
                busca: busca,
                area_min: area_min,
                area_max: area_max,
            },
            success: function (response) {
                $("#imoveisLista").html(response);
                $('#imoveisLista').removeClass('loading');
                ScrollTrigger.refresh();
                return false;
            }
        });
    }

    //FILTRO BLOG
    $('#filtroBlog .form-check-input').on('change', function () {
        filtrarBlog();
    });
    
    $('#filtroBlog #filtroBusca').on('keyup', function () {
        filtrarBlog();
    });
    
    function filtrarBlog() {
        var categorias = $('#filtroBlog .form-check-input:checked').map(function () {
            return $(this).val();
        }).get();
        
        var busca = $('#filtroBusca').val();
    
        $('#blogLista').addClass('loading');
        $.ajax({
            type: 'POST',
            url: ajaxurl,
            data: { 
                "action": "filtro-blog",
                categorias: JSON.stringify(categorias),
                busca: busca
            },
            success: function (response) {
                $("#blogLista").html(response);
                $('#blogLista').removeClass('loading');
            }
        });
    }

    //CARROSSEL
    $('.owl-empreendimento').owlCarousel({
        loop: true,
        margin: 20,
        nav: true,
        navText: [
            '<img src="/wp-content/themes/grupogp/assets/img/arrow-left.png" alt="Anterior">',
            '<img src="/wp-content/themes/grupogp/assets/img/arrow-right.png" alt="Próximo">'
        ],
        responsive: {
            0: {
                items: 1
            },
            768: {
                items: 2
            }
        }
    });

    $('.owl-depoimentos').owlCarousel({
        loop: true,
        nav: true,
        autoplay:true,
        autoplayTimeout:2000,
        autoplayHoverPause:true,
        navText: [
            '<img src="/wp-content/themes/grupogp/assets/img/arrow-left.png" alt="Anterior">',
            '<img src="/wp-content/themes/grupogp/assets/img/arrow-right.png" alt="Próximo">'
        ],
        items: 1,
    });

    $(window).scroll(function(){
        if($(this).scrollTop()>0){
            $('#mainNav').addClass('scroll')
        } else{
            $('#mainNav').removeClass('scroll')
        }
    });

    //SMOOTH SCROLL - USAR SEMPRE NO FINAL
    // gsap.registerPlugin(ScrollTrigger);
    // if ($(".scroll-container").length) {
    //     var scroller = document.querySelector(".scroll-container");
    //     smoothScroll(scroller);
    // }
});

// CONTADOR
document.addEventListener("DOMContentLoaded", function() {
	var countUpElements = document.querySelectorAll('.count-up');

	var options = {
		threshold: 0.5
	};

	var observer = new IntersectionObserver(function(entries, observer) {
		entries.forEach(function(entry) {
			if (entry.isIntersecting) {
				startCountUp(entry.target);
				observer.unobserve(entry.target);
			}
		});
	}, options);

	countUpElements.forEach(function(element) {
		observer.observe(element);
	});

	function startCountUp(element) {
		var from = parseInt(element.getAttribute('data-from'));
		var to = parseInt(element.getAttribute('data-to'));
		var speed = parseInt(element.getAttribute('data-speed')) || 100;

		var current = from;
		var interval = setInterval(function() {
			element.textContent = current;

			if (current < to) {
				current++;
			} else {
				clearInterval(interval);
			}
		}, speed);
	}
});

//BOTAO CARREGAR MAIS
let postsToShow = 6;
let currentPostIndex = postsToShow;
let postsPerClick = 2;

// Identifica a lista correta na página
const listContainer = document.getElementById('imoveisLista') || document.getElementById('blogLista');
const loadMoreButton = document.getElementById('loadmore');

function showMorePosts() {
    const posts = listContainer.querySelectorAll('.imovel-card');
    const totalPosts = posts.length;

    for (let i = currentPostIndex; i < currentPostIndex + postsPerClick; i++) {
        if (posts[i]) {
            posts[i].classList.add('visible');
        }
    }

    currentPostIndex += postsPerClick;

    if (currentPostIndex >= totalPosts) {
        loadMoreButton.style.display = 'none';
    }
}

function resetLoadMore() {
    const posts = listContainer.querySelectorAll('.imovel-card');
    const totalPosts = posts.length;

    for (let i = 0; i < totalPosts; i++) {
        posts[i].classList.remove('visible');
    }

    for (let i = 0; i < postsToShow; i++) {
        if (posts[i]) {
            posts[i].classList.add('visible');
        }
    }

    currentPostIndex = postsToShow;
    loadMoreButton.disabled = false;

    if (totalPosts < 7) {
        loadMoreButton.style.display = 'none';
    } else {
        loadMoreButton.style.display = 'block';
    }
}

const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
        if (mutation.type === 'childList') {
            resetLoadMore();
        }
    });
});

if (listContainer) {
    observer.observe(listContainer, {
        childList: true,
        subtree: true
    });
    loadMoreButton.addEventListener('click', showMorePosts);
    document.addEventListener("DOMContentLoaded", resetLoadMore);
}


